<script>
	import { Col, Row } from "sveltestrap";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import VehicleDataTable from "./VehicleDataTable.svelte";

	let data = [
		{
			name: "Vehicle Make",
			route: "/master-data/vehicle-data/vehicle-make",
		},
		{
			name: "Vehicle Model",
			route: "/master-data/vehicle-data/vehicle-model",
		},
		{
			name: "Vehicle Type",
			route: "/master-data/vehicle-data/vehicle-type",
		},
		{
			name: "Vehicle Color",
			route: "/master-data/vehicle-data/vehicle-color",
		},
		{
			name: "Vehicle Fuel Type",
			route: "/master-data/vehicle-data/vehicle-fuel",
		},
		{
			name: "Vehicle Asset Owner",
			route: "/master-data/vehicle-data/vehicle-asset-owner",
		},
		{
			name: "Carpark Owner",
			route: "/master-data/vehicle-data/carpark-owner",
		},
		{
			name: "Fuel Company",
			route: "/master-data/vehicle-data/fuel-company",
		},
		{
			name: "Vehicle Photos",
			route: "/master-data/vehicle-data/vehicle-photos",
		},
		{
			name: "Vehicle Efficiency",
			route: "/master-data/vehicle-data/vehicle-efficiency",
		},
		{
			name: "EV CPO Provider",
			route: "/master-data/vehicle-data/ev-cpo-provider",
		},
	];
	// let totalPages;
</script>

<Row>
	<Col xs={12}>
		<div>
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Vehicle Master Data" />
			</Col>
		</div>
	</Col>
	<Col class="my-2">
		<VehicleDataTable {data} />
	</Col>
</Row>
